import { render } from "./PromocodeUseTab.vue?vue&type=template&id=6560d7ee"
import script from "./PromocodeUseTab.vue?vue&type=script&lang=js"
export * from "./PromocodeUseTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__